import { render } from "./addNewCorporate.vue?vue&type=template&id=d54c1212&scoped=true"
import script from "./addNewCorporate.vue?vue&type=script&lang=js"
export * from "./addNewCorporate.vue?vue&type=script&lang=js"

import "./addNewCorporate.vue?vue&type=style&index=0&id=d54c1212&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d54c1212"]])

export default __exports__